export function fontsReady() {
  if ((document as any).fonts) {
    return Promise.all([
      (document as any).fonts.ready,
      new Promise((resolve) => setTimeout(resolve, 50)),
    ])
  } else {
    return new Promise((resolve) => setTimeout(resolve, 300))
  }
}
